import {SearchOptionsRequest} from '../../../../../shared/models/SearchOptionsRequest.model';
import TrackStatus from '../models/TrackStatus.enum';

export class InvestmentSearchOptions extends SearchOptionsRequest {
  trackStatus: TrackStatus;
}
